import React from "react";
import { TablePagination } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import PropTypes from "prop-types";

import { useStyles } from "./CustomDataGrid.styles";

const CustomDataGrid = ({
  onPageChange,
  page,
  pageSize,
  rowCount,
  disablePagination,
  onPageSizeChange,
  rowsPerPageOptions,
  paginationOnlyBottom = false,
  customRowHeight,
  ...props
}) => {
  const classes = useStyles();

  function Pagination() {
    return (
      <TablePagination
        component="div"
        count={parseInt(rowCount)}
        rowsPerPage={pageSize}
        page={page}
        onPageChange={onPageChange}
        rowsPerPageOptions={rowsPerPageOptions}
        onRowsPerPageChange={onPageSizeChange}
        data-testid="table-pagination"
      />
    );
  }
  return (
    <div className={[classes.dataWrapper, props.wrapperClassName].join(" ")}>
      <div className={classes.filterBar}>
        {props?.filter && props.filter}
        {!disablePagination && !paginationOnlyBottom && <Pagination />}
      </div>
      <DataGrid
        className={`${classes.dataGrid} ${
          props.rowHoverMousePtr ? classes.rowHoverMousePtr : null
        } ${customRowHeight ? classes.customRowHeight : ""}`}
        {...props}
        hideFooter
      />
      {!disablePagination && (
        <div className={classes.paginationBottom}>
          <Pagination />
        </div>
      )}
    </div>
  );
};

CustomDataGrid.defaultProps = {
  customRowHeight: false,
};

CustomDataGrid.propTypes = {
  wrapperClassName: PropTypes.string,
  filter: PropTypes.node,
  rowHoverMousePtr: PropTypes.bool,
  onPageChange: PropTypes.func,
  page: PropTypes.number,
  pageSize: PropTypes.number,
  rowCount: PropTypes.any,
  disablePagination: PropTypes.bool,
  onPageSizeChange: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  paginationOnlyBottom: PropTypes.bool,
  loading: PropTypes.bool,
  customRowHeight: PropTypes.bool,
};

export { CustomDataGrid };
